<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Fluid type - {{this.subTitle}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col lg="6">
				<!-- <b-btn class="pull-right" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="configTable = true"><i class="fa fa-cog"></i></b-btn> -->
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editFT">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteFT">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
					<!-- <b-tab title="Operating Area" active> -->
						<b-row>
							<b-col md="8">

								<b-form-group :label-cols="4" id="L1" label="Fluid Type Name" label-for="ftID" horizontal>
									<b-form-input class="plaintext-input" v-show="!edit" plaintext id="ftID" v-model="fluidTypeName" type="text"></b-form-input>
									<b-form-input class="plaintext-input" v-show="edit" id="CompanyNameID" v-model="fluidTypeName" type="text"></b-form-input>
								</b-form-group>
								<b-form-group :label-cols="4" id="L1" label="Isolera Fluid Type Name" label-for="ftID" horizontal>
									<b-form-input class="plaintext-input" v-show="!edit" plaintext id="ftID" v-model="isolera_fluid_type_name" type="text"></b-form-input>
									<b-form-input class="plaintext-input" v-show="edit" id="CompanyNameID" v-model="isolera_fluid_type_name" type="text"></b-form-input>
								</b-form-group>

								<b-form-group :label-cols="4" id="L2" label="Fluid Type Color" label-for="color" horizontal>
									<b-form-input id="color" :disabled='!edit' v-model="fluidTypeColor" type="color"></b-form-input>
								</b-form-group>

								<div slot="footer" v-show="edit">
									<b-button @click="updateFT" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
									<b-button @click="editFT" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
								</div>
							</b-col>
						</b-row>
					<!-- </b-tab> -->
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import fluidtypes from './fluidtypes'

	export default {
		name: 'mFluidType',
		created: function() {
			this.getFluidType()
		},
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		data() {
			return {
				subTitle: '',
				edit: false,
				found: false,
        		notFoundMessage: 'Not found',
				fluidTypeColor: '#ffff00',
        		fluidTypeName: '',
        		isolera_fluid_type_name: '',
				updateData: null,
				originalData: null,
				loadingData: true,
			}
		},
		methods: {
			editFT() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.setupFields()
					this.edit = true
				}
			},
			restoreOriginalData() {
        		this.fluidTypeName 	= this.originalData.name
        		this.isolera_fluid_type_name 	= this.originalData.isolera_fluid_type_name
				this.fluidTypeColor = this.originalData.color
			},
			setupFields() {
        		this.fluidTypeName 	= this.originalData.name
        		this.isolera_fluid_type_name 	= this.originalData.isolera_fluid_type_name
				this.fluidTypeColor = this.originalData.color
			},
			getFluidType() {
				fluidtypes.getBy(this.id)
					.then(data => {
						if (data.status == 'success') {
							this.originalData = data.data
							this.loadingData = false
							this.found = true
							this.restoreOriginalData()
							this.subTitle = this.originalData.name
						}else {
							this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              // this.getAll()
              return
						}

					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
				if (this.fluidTypeName === undefined || this.fluidTypeName.trim().length == 0) {
					this.$swal('Alert!', 'Fluid Type Name can not be empty', 'warning')
					return false
				}
				if (this.fluidTypeColor === undefined || this.fluidTypeColor.trim().length == 0) {
					this.$swal('Alert!', 'Fluid Type Color invalid', 'warning')
					return false
				}
				return true
			},
      		updateFT () {
        		if (!this.okToUpdate()) {
					return
				}

				let model = {
          			name	: this.fluidTypeName,
          			isolera_fluid_type_name	: this.isolera_fluid_type_name,
          			color 	: this.fluidTypeColor
				}
				console.log(model)
				fluidtypes.update(this.id, model)
					.then((data) => {
						this.$swal(data[0], data[1], data[0])
							.then((result) => {
								this.getFluidType()
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit=false
			},
			deleteFT(item) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Fluid Type: " + this.fluidTypeName + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						fluidtypes.delete(this.id)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.replace('/fluid_types')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/m_fluid_types/m_fluid_type.vue